export const TYPE_PRIMARY = "type/BLACK";
export const TYPE_SECONDARY = "type/WHITE";
export const TYPE_SUCCESS = "type/SUCCESS";
export const TYPE_FAILURE = "type/FAILURE";
export const TYPE_INFO = "type/INFO";
export const TYPE_FB_SHARE = "type/FACEBOOK";
export const TYPE_WHATSAPP_SHARE = "type/WHATSAPP";
export const TYPE_WARNING = "type/WARNING";

export const CLR_BLACK = "#000";
export const CLR_WHITE = "#fff";
export const CLR_LIGHTGREY = "#efefef";
export const CLR_GREY = "#ccc";
export const CLR_PRIMARY = "#31708f";
export const CLR_SECONDARY = "#000";
export const CLR_TRANSPARENT = "transparent";

export const COLORS: Record<string, Record<string, string>> = {
    [TYPE_SUCCESS]: {
        color: "#28a745",
        borderColor: "#d0e9c6",
        backgroundColor: "#dff0d8",
    },
    [TYPE_FAILURE]: {
        color: "#a94442",
        borderColor: "#ebcccc",
        backgroundColor: "#f2dede",
        hoverColor: "#fff",
        hoverBackgroundColor: "#f00",
    },
    [TYPE_INFO]: {
        color: "#fff",
        borderColor: "#1976d2",
        backgroundColor: "#1976d2",
    },
    [TYPE_FB_SHARE]: {
        color: "#fff",
        borderColor: "#3b5998",
        backgroundColor: "#3b5998",
    },
    [TYPE_WHATSAPP_SHARE]: {
        color: "#fff",
        borderColor: "#34a962",
        backgroundColor: "#34a962",
    },
    [TYPE_WARNING]: {
        color: "#fcf8e3",
        borderColor: "#faf2cc",
        backgroundColor: "#fcf8e3",
        hoverColor: "#fcf8e3",
        hoverBackgroundColor: "#faf2cc",
    },
    [TYPE_PRIMARY]: {
        color: "#fff",
        borderColor: "#000",
        backgroundColor: "#000",
    },
    [TYPE_SECONDARY]: {
        color: "#999",
        borderColor: "#f3f3f3",
        backgroundColor: "#f3f3f3",
        hoverColor: "#fff",
        hoverBackgroundColor: "#000",
    },
};
